module.exports = __webpack_public_path__ + "vodafone-logo-short-inverted.846cea22cc90e9e273a90e661b7ba305.svg";